import React from 'react';
import customStyles from "../../../../assets/styles/customStyles";

export const NoData = () => {
    const classes = customStyles();
    return (
        <div className={classes.noData}>Data Will be Displayed when transactions are recorded by the system</div>
    )
}